import React, { createContext } from 'react'
import { defaultLanguage } from './locales'

interface LanguageProviderProps {
  language: string
  setLanguage: (language: string) => void
  children?: React.ReactNode
}

export const LanguageContext = createContext<LanguageProviderProps>({
  language: defaultLanguage,
  setLanguage: () => void 0,
  children: null
})
